export default "__VITE_ASSET__Dfy3jz2O__"